import { render, staticRenderFns } from "./dialogToolbar.vue?vue&type=template&id=584a400f&scoped=true&lang=pug"
import script from "./dialogToolbar.vue?vue&type=script&lang=ts"
export * from "./dialogToolbar.vue?vue&type=script&lang=ts"
import style0 from "./dialogToolbar.vue?vue&type=style&index=0&id=584a400f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584a400f",
  null
  
)

export default component.exports